import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <br>
      </br>
      <br>
      </br>
      <br>
      </br>
      <br>
      </br>
      <h2>
        Hamsters Adopted so far
      </h2>
      <p>Upload your new hamster</p>
    </div>
  )
}

export default Title;